import { z } from "zod";

import { looseArray } from "../looseParse";

export const accountInviteStatusSchema = z.enum([
  "pending",
  "accepted",
  "revoked",
  "expired",
]);

export const accountInviteSchema = z.object({
  id: z.string(),
  account_id: z.string(),
  inviter_owner_id: z.string(),
  invitee_email: z.string(),
  invitee_role: z.string(),
  status: accountInviteStatusSchema,
  expires_at: z.string(),
  accepted_at: z.string().nullable(),
  revoked_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const accountInviteResponseSchema = z.object({
  invite: accountInviteSchema,
});

export const listAccountInvitesResponseSchema = z.object({
  invites: looseArray(
    accountInviteSchema,
    "listAccountInvitesResponseSchema.invites",
  ),
  next_cursor: z.string().nullable(),
});
